import { getDesktopStructure } from 'crazyEditor/core/elements/dataConversation/oldStructureConversation';
import { convertInlineStyleToReactStyleObj } from 'crazyEditor/core/utils/styleUtils';
import $ from 'jquery';

function getNormalizedElementStructure(desktopBackgroundElementProps, desktopPageElementProps, desktopElements, mobilePageElementProps = {}) {
  return {
    desktop: {
      PageElement: {
        compProps: convertInlineStyleToReactStyleObj(desktopBackgroundElementProps) || {}
      },
      BackgroundElement: {
        compProps: convertInlineStyleToReactStyleObj(desktopPageElementProps) || {}
      },
      elements: getDesktopStructure(desktopElements)
    },
    mobile: {
      PageElement: {
        compProps: convertInlineStyleToReactStyleObj(mobilePageElementProps) || {}
      }
    }
  };
}

function getStructureForTemplateV1($desktopWrapper) {
  const $desktopView = $desktopWrapper.find('#desktopContainer');

  return getNormalizedElementStructure(
    $desktopWrapper.attr('style'),
    $desktopView.attr('style'),
    $desktopView.html()
  );
}

function getStructureForTemplateV2($template) {
  const $desktopWrapper = $template.find('#desktop-wrapper');
  const $desktopView = $template.find('#desktop-view');
  const $mobileView = $template.find('#mobile-view');

  return getNormalizedElementStructure(
    $desktopWrapper.attr('style'),
    $desktopView.attr('style'),
    $desktopView.html(),
    $mobileView.attr('style')
  );
}

function parseTemplate(html) {
  const $template = $(html);
  if ($template.attr('id') === 'editor-template-wrapper') {
    if ($template.data('template-version') === 2) {
      return getStructureForTemplateV2($template);
    }
    throw Error('Unknown template version');
  }
  return getStructureForTemplateV1($template);
}

export {
  parseTemplate
};
